export const LICENSE_TYPES = [
  { label: "Временная", value: 0 },
  { label: "Бессрочная", value: 1 },
  { label: "Сессионная", value: 2 },
];

export type LicenseTypeValue = (typeof LICENSE_TYPES)[number]["value"];
